// extracted by mini-css-extract-plugin
module.exports = {"modal-phone-header":"AppModalPhoneHeader_modal-phone-header__10W6L","profile":"AppModalPhoneHeader_profile__2exTn"};